import 'antd/dist/antd.min.css';
import './App.css';
import AppRoutes from 'src/routes';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import reduxConfig from 'src/redux/config';
// import to init firebase
import firebase from 'src/firebase';

function App() {
  return (
    <Provider store={reduxConfig.store}>
      <PersistGate loading={null} persistor={reduxConfig.persistor}>
        <AppRoutes />
      </PersistGate>
    </Provider>
  );
}

export default App;
